import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import { tracker as CLICKSTREAM, type ClickstreamPayload } from '@zg-rentals/clickstream';
import { tracker as COMSCORE } from '@zg-rentals/comscore/client';
import { tracker as GTM } from '@zg-rentals/google-tag-manager';
import type { RentalApplication } from '@zg-rentals/clickstream';
import type { OptimizelyInfo, RentalApplicationTerm } from './types';

export const analytics = defineAnalytics({ GTM, COMSCORE, CLICKSTREAM });

export const trackComscoreEvent = analytics.createTrackEvent('COMSCORE');

export const trackEvent = analytics.createTrackEvent('CLICKSTREAM');

export const trackRentalApplicationEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<RentalApplication>
>('CLICKSTREAM');

export const trackTermEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<RentalApplication & RentalApplicationTerm>
>('CLICKSTREAM');

export const trackOptimizelyEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<RentalApplication & OptimizelyInfo>
>('CLICKSTREAM');

export const trackSearchCsEvent = analytics.createTrackEvent<
  'CLICKSTREAM',
  ClickstreamPayload<{ search_term: string }>
>('CLICKSTREAM');
